// extracted by mini-css-extract-plugin
export default {"container":"upsert_container__qTw3z","success":"upsert_success__hV5hB","img":"upsert_img__TvFUc"};